import { startOfDay, subDays } from "date-fns";
import { useGetList, useTranslate } from "ra-core";
import { Link } from "react-router";

import { LeadKpiTiles } from "../leads/LeadKpiTiles";
import { computeKpis } from "../leads/leadUtils";
import type { Lead } from "../types";

const SINCE_DAYS = 30;

/** Kurzfassung der Lead-Kennzahlen auf dem Dashboard. */
export const LeadDashboardKpis = () => {
  const translate = useTranslate();
  const { data, isPending } = useGetList<Lead>("leads", {
    // Tagesgenau, damit die Abfrage im Cache bleibt und mit der Kennzahlen-Seite geteilt wird
    filter: {
      "created_at@gte": startOfDay(
        subDays(new Date(), SINCE_DAYS),
      ).toISOString(),
    },
    sort: { field: "created_at", order: "DESC" },
    pagination: { page: 1, perPage: 1000 },
  });

  if (isPending || !data?.length) return null;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-medium text-muted-foreground">
          {translate("crm.kpi.last_days", { days: SINCE_DAYS })}
        </h2>
        <Link to="/kennzahlen" className="text-sm underline hover:no-underline">
          {translate("crm.kpi.title")}
        </Link>
      </div>
      <LeadKpiTiles kpis={computeKpis(data)} />
    </div>
  );
};
